// all drawer are imported here
import DetailDrawer from "./drawers/DetailDrawer";
import EditDrawer from "./drawers/EditDrawer";
import InfoDrawer from "./drawers/InfoDrawer";

const OrganonOrderingCart = () => {
    return (
        <>
            <InfoDrawer />
            <EditDrawer />
            <DetailDrawer />
        </>
    )
}

export default OrganonOrderingCart